/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getCookie } from 'utils/cookie';

const requestInterceptor = (request: InternalAxiosRequestConfig<any>) => {
  const accessToken = getCookie('_TOKEN_BFF');

  if (accessToken) {
    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }
  return request;
};

const responseInterceptorFullFilled = (response: AxiosResponse) => response.data;

const responseInterceptorRejected = (err: any) => {
  if (err.response === undefined) {
    const error = new Error('Não foi possível conectar ao servidor.');

    return Promise.reject(error.stack);
  }

  if (err.response.status === 401) {
    if (process.env.NODE_ENV !== 'development') window.location.assign(process.env.FRETEBRAS_LOGOUT_URL);
    return Promise.resolve();
  }

  return Promise.reject(err);
};

export { requestInterceptor, responseInterceptorFullFilled, responseInterceptorRejected };
